import React from 'react';
import { motion } from 'framer-motion';
export function FinalCTA() {
  return <section className="bg-navy text-cream py-32 px-5 relative overflow-hidden border-t border-gold/20" data-id="element-51">
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,_var(--tw-gradient-stops))] from-gold/10 via-navy to-navy" data-id="element-52"></div>

      <div className="max-w-4xl mx-auto text-center relative z-10" data-id="element-53">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="font-playfair text-4xl md:text-5xl lg:text-6xl font-bold mb-10 leading-tight" data-id="element-54">
          Dejá de competir por precio.
        </motion.h2>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.2
      }} data-id="element-55">
          <a href="https://1marvt-uy.myshopify.com/checkouts/cn/hWNA9wnUkaCuu217d67e9GxW/es-ar?_r=AQABvb9kJNeai9b90xDQXdccT9ieTUuslKeR07HVYPreqzk&preview_theme_id=184270029099" target="_blank" rel="noopener noreferrer" className="inline-block w-full md:w-auto bg-gold text-navy font-dmsans font-bold text-xl py-5 px-10 rounded hover:bg-cream hover:scale-105 transition-all duration-300 shadow-[0_0_30px_rgba(201,168,76,0.3)]" data-id="element-56">
            Descargá el E-book ahora — $19.990
          </a>
        </motion.div>
      </div>
    </section>;
}